module.exports = __webpack_public_path__ + "static/media/yoga.2dfc47c2.jpg";